import React from "react";
import RightIcon from "@mui/icons-material/East";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Divider } from "@mui/material";

import useEditorStore from './editorStore';
import { getBatches } from "services";
import { Session } from "utils";
import CustomButton from "components/CustomButtons";

function NewTag(props) {
  return (
    <Box
      style={{
        padding: "5px 12px 6px",
        borderRadius: "4px",
        position: 'absolute',
        backgroundColor: '#8270DB',
        right: 16,
        top: 16,
      }}
    >
      <Typography variant="overline-bold" color={'tertiary.clr-50'} fontSize='12px'>
        MOSTLY USED
      </Typography>
    </Box>
  );
}

function MethodSelection(props) {
  const nextSection = useEditorStore(state => state.nextStep);
  const setAutoGenerate = useEditorStore(state => state.setAutoGenerate);

  const [batchExists, setBatchExists] = React.useState(true);

  React.useEffect(() => {
    getBatches({ client: Session.userId, includeTotal: true }).then(({ total }) => {
      if (!total) setBatchExists(false);
    }).catch(console.error);
  }, []);

  const clickHandler = (autoGenerate) => () => {
    setAutoGenerate(autoGenerate);
    nextSection();
  };

  return (
    <Box {...props} overflow="hidden" pl={2}>
      <Typography
        variant="h4-medium"
        pt={2}
        pl={2}
        pb={0}
      >
        Choose Creation Method
      </Typography><br/>
      <Typography
        variant="h6-medium"
        color='neutral.clr-600'
        pt={0}
        pl={2}
        pb={2}
      >
        Select how you want to create your assessment
      </Typography>
      <Divider style={{ marginTop: '16px', marginBottom: '28px'}} />
      <Box
        display="flex"
        alignItems="stretch"
        gap={4}
        justifyContent="center"
        mt={2}
        mb={4}
      >
        <Box
          maxWidth={400}
          border="3px solid #D3D8DE"
          flex="1 0 0"
          p={5}
          borderRadius={2}
          position="relative"
          display="flex"
          flexDirection="column"
          justifyContent='space-between'
        >
          <Box>
          <Typography variant="h6-semiBold">
            Auto-Generate all<br />questions & answers
          </Typography>
          <NewTag />
          <Typography variant="body01-bold" color='neutral.clr-700'>
            <ol style={{ flexGrow: 1 }}>
              <li>Enter Assessment Details</li>
              <li>Questions & answers are auto-generated</li>
              <li>View or edit questions and answers as needed</li>
              <li>Add assessment details and publish assessment</li>
            </ol>
          </Typography>
          </Box>
          <CustomButton
            disabled={!batchExists}
            style={{ width: '100%' }}
            endIcon={<RightIcon />}
            onClick={clickHandler(true)}
          >
            Proceed
          </CustomButton>
        </Box>
        <Box
          maxWidth={400}
          border="3px solid #D3D8DE"
          flex="1 0 0"
          p={5}
          borderRadius={2}
        >
          <Typography variant="h6-semiBold">
            Manually type or import all desired questions and answers
          </Typography>

          <Typography variant="body01-bold" color='neutral.clr-700'>
            <ol style={{ flexGrow: 1 }}>
              <li>Enter Assessment Details</li>
              <li>Type out questions one-by-one or import questions altogether</li>
              <li>Type out answers one-by-one or auto-generate ideal answers</li>
              <li>Add assessment details and publish assessment</li>
            </ol>
          </Typography>
          <CustomButton
            disabled={!batchExists}
            style={{ width: '100%' }}
            endIcon={<RightIcon />}
            onClick={clickHandler(false)}
          >
            Proceed
          </CustomButton>
        </Box>

      </Box>
      {(!batchExists) && <Box
        display='flex' justifyContent='center' alignItems='center'
      >
        <Typography
          variant="body1"
          fontWeight={600}
          component="div"
          color='red'
        >
          ** A batch is required before creating an assessment.
          Please create a batch first.
        </Typography> &nbsp;
        <a href="/batches/create" style={{
          color: "#013B6B", fontSize: 16, fontWeight: 600
        }}>
          Create Batch
        </a>
      </Box>}

    </Box>
  );
}

export default MethodSelection;